const questions = [
{
question: "Какой результат вернёт формула =СУММ(2;3;5)?",
options: ["5", "8", "10", "Ошибка"],
answer: "10",
},
{
question: "Какая функция ищет значение в таблице по ключу?",
options: ["ВПР", "ЕСЛИ", "СУММЕСЛИ", "ИНДЕКС"],
answer: "ВПР",
},
{
question: "Как вставить текущую дату в ячейку?",
options: ["Ctrl + Shift + D", "Ctrl + ;", "Ctrl + Alt + T", "Alt + Enter"],
answer: "Ctrl + ;",
},
{
question: "Какая комбинация клавиш закрепляет ячейку в формуле ($)?",
options: ["Ctrl + K", "F2", "F4", "Shift + $"],
answer: "F4",
},
{
question: "Как объединить содержимое ячеек в одну строку (Excel)?",
options: ["CONCAT", "JOIN", "MERGE", "TEXTJOIN"],
answer: "TEXTJOIN",
},
{
question: "Какая функция возвращает наибольшее значение в диапазоне?",
options: ["МАКС", "МИН", "СРЗНАЧ", "СЧЁТ"],
answer: "МАКС",
},
{
question: "Какой инструмент используется для поиска и удаления дубликатов?",
options: ["Фильтр", "Сортировка", "Удаление дубликатов", "СУММЕСЛИ"],
answer: "Удаление дубликатов",
},
{
question: "Какое расширение имеет файл Google Sheets при экспорте в Excel?",
options: [".xlsx", ".gsheet", ".xls", ".csv"],
answer: ".xlsx",
},
{
question: "Какой результат вернёт формула =ЕСЛИ(5>3;Да;Нет)?",
options: ["Нет", "Ошибка", "5>3", "Да"],
answer: "Да",
},
{
question: "Как вставить перенос строки в ячейке Excel?",
options: ["Ctrl + Enter", "Alt + Enter", "Shift + Enter", "Enter"],
answer: "Alt + Enter",
},
{
question: "Как посчитать количество чисел в диапазоне (Excel)?",
options: ["СЧЁТЗ", "СУММ", "СЧЁТ", "ДЛСТР"],
answer: "СЧЁТ",
},
{
question: "Как построить сводную таблицу в Google Sheets?",
options: ["Вставка → Диаграмма", "Данные → Сводная таблица", "Вставка → Таблица", "Формулы → Пивот"],
answer: "Данные → Сводная таблица",
},
{
question: "Как закрепить первую строку при прокрутке?",
options: ["Вид → Закрепить → 1 строку", "Данные → Фильтр", "Вид → Сортировка", "Разметка страницы"],
answer: "Вид → Закрепить → 1 строку",
},
{
question: "Какая функция объединяет диапазоны данных в Google Sheets?",
options: ["VLOOKUP", "ARRAYFORMULA", "QUERY", "IMPORTRANGE"],
answer: "IMPORTRANGE",
},
{
question: "Какая функция находит среднее арифметическое?",
options: ["МАКС", "СРЗНАЧ", "МИН", "СЧЁТ"],
answer: "СРЗНАЧ",
},
{
question: "Как в Excel быстро пронумеровать строки (1,2,3…)?",
options: [
"Ввести 1 и 2, выделить и протянуть",
"Ввести формулу СЧЁТ",
"Вставить таблицу",
"Автозаполнение через Ctrl + A"
],
answer: "Ввести 1 и 2, выделить и протянуть",
},
{
question: "Как создать выпадающий список в ячейке?",
options: [
"Формулы → ВПР",
"Данные → Проверка данных",
"Вставка → Таблица",
"Файл → Настройки"
],
answer: "Данные → Проверка данных",
},
{
question: "Какая функция возвращает текущее время?",
options: ["СЕГОДНЯ", "ТДАТА", "ТВРЕМЯ", "ТДАТАВРЕМЯ"],
answer: "ТВРЕМЯ",
},
{
question: "Как сделать, чтобы формула не изменялась при копировании?",
options: [
"Использовать знак доллара ($) в адресе",
"Зафиксировать ячейку через Shift",
"Использовать абсолютные значения",
"Выделить и заблокировать через Ctrl + B"
],
answer: "Использовать знак доллара ($) в адресе",
},
{
question: "Какой формат файла лучше использовать для обмена данными между Excel и Google Sheets?",
options: [".csv", ".txt", ".xls", ".docx"],
answer: ".csv",
},
{
question: "Какая функция объединяет текст и числа в одной ячейке?",
options: ["СУММ", "ВПР", "СЦЕПИТЬ", "ИТОГИ"],
answer: "СЦЕПИТЬ",
},
{
question: "Какая функция возвращает текущую дату без времени?",
options: ["СЕГОДНЯ", "ТДАТА", "ТДАТАВРЕМЯ", "ДАТА"],
answer: "СЕГОДНЯ",
},
{
question: "Как включить автоматический перенос текста в ячейке?",
options: ["Формат → Перенос текста", "Вид → Закрепить", "Данные → Сортировка", "Файл → Настройки"],
answer: "Формат → Перенос текста",
},
/* {
question: "Как быстро вставить строку в Google Sheets?",
options: ["Ctrl + Shift + +", "Ctrl + I", "Ctrl + Enter", "Alt + Insert"],
answer: "Ctrl + Shift + +",
}, */
{
question: "Какая функция считает количество непустых ячеек?",
options: ["СЧЁТЗ", "СЧЁТ", "СУММ", "ПУСТО"],
answer: "СЧЁТЗ",
},
{
question: "Какое сочетание клавиш копирует содержимое ячейки?",
options: ["Ctrl + X", "Ctrl + C", "Ctrl + D", "Ctrl + V"],
answer: "Ctrl + C",
},
{
question: "Как открыть строку поиска и замены в Excel?",
options: ["Ctrl + H", "Ctrl + F", "Ctrl + Shift + F", "Alt + Q"],
answer: "Ctrl + H",
},
{
question: "Как быстро выделить весь столбец в Excel?",
options: ["Ctrl + Shift + A", "Shift + End", "Щёлкнуть по букве столбца", "Alt + Enter"],
answer: "Щёлкнуть по букве столбца",
},
{
question: "Как удалить дубликаты в Google Sheets?",
options: ["Файл → Очистить", "Формулы → СУММ", "Данные → Удалить дубликаты", "Данные → Сортировка"],
answer: "Данные → Удалить дубликаты",
},
{
question: "Какая функция проверяет условие и возвращает результат?",
options: ["МАКС", "ЕСЛИ", "СРЗНАЧ", "ВПР"],
answer: "ЕСЛИ",
},
{
question: "Как быстро отфильтровать таблицу?",
options: ["Вид → Закрепить", "Формулы → Фильтр", "Файл → Настройки", "Данные → Создать фильтр"],
answer: "Данные → Создать фильтр",
},
{
question: "Какая функция возвращает номер строки?",
options: ["СТОЛБЕЦ", "ИНДЕКС", "СТРОКА", "АДРЕС"],
answer: "СТРОКА",
},
{
question: "Как ввести новую строку внутри ячейки Google Sheets?",
options: ["Alt + Enter", "Shift + Enter", "Ctrl + Enter", "Alt + Shift + L"],
answer: "Ctrl + Enter",
},
{
question: "Какая функция возвращает адрес ячейки?",
options: ["СЦЕПИТЬ", "ИНДЕКС", "ВПР", "АДРЕС"],
answer: "АДРЕС",
},
{
question: "Как создать фильтр по диапазону?",
options: ["Формат → Диапазон","Данные → Фильтр", "Вставка → Таблица", "Файл → Фильтр"],
answer: "Данные → Фильтр",
},
{
question: "Как включить автосумму (Excel)?",
options: ["Alt + =", "Ctrl + Enter", "Shift + S", "Ctrl + Shift + S"],
answer: "Alt + =",
},
{
question: "Какая функция возвращает количество строк в диапазоне?",
options: ["СТОЛБЦОВ", "СТРОК", "СЧЁТ", "ДЛСТР"],
answer: "СТРОК",
},
{
question: "Какой раздел отвечает за создание диаграмм?",
options: ["Данные → Сортировка", "Формат → Стили", "Вставка → Диаграмма", "Файл → Настройки"],
answer: "Вставка → Диаграмма",
},
{
question: "Какая функция возвращает первое совпадение по условию?",
options: ["ГПР", "ВПР", "ЕСЛИ", "МАКС"],
answer: "ВПР",
},
{
question: "Какой формат используется для сохранения макросов?",
options: [".xlsx", ".csv", ".xlsm", ".docx"],
answer: ".xlsm",
},
{
question: "Как быстро перейти к началу таблицы?",
options: ["Ctrl + End", "Ctrl + Up", "Ctrl + Home", "Ctrl + G"],
answer: "Ctrl + Home",
},
{
question: "Какая функция преобразует текст в верхний регистр?",
options: ["СТРОЧН", "ТЕКСТ", "ПРАВО", "ПРОПИСН"],
answer: "ПРОПИСН",
},
{
question: "Как объединить ячейки (без текста)?",
options: ["Вставка → Таблица", "Данные → Сортировка", "Формат → Объединить ячейки", "Файл → Настройки"],
answer: "Формат → Объединить ячейки",
},
{
question: "Как вставить формулу быстрого суммирования в Google Sheets?",
options: ["Alt + =", "Ctrl + +", "Shift + =", "Ctrl + Alt + S"],
answer: "Alt + =",
},
{
question: "Какое сочетание клавиш копирует формулу из ячейки выше?",
options: ["Ctrl + D", "Ctrl + Shift + C", "Ctrl + Enter", "Alt + Down"],
answer: "Ctrl + D",
},
{
question: "Какая функция ищет позицию элемента в диапазоне?",
options: ["ИНДЕКС", "ВПР", "ПОИСКПОЗ", "СТРОКА"],
answer: "ПОИСКПОЗ",
},
{
question: "Как задать числовой формат с двумя знаками после запятой?",
options: ["Вид → Настройки", "Данные → Сортировка", "Формат → Число → Числовой", "Формулы → Текст"],
answer: "Формат → Число → Числовой",
},
{
question: "Какая функция вычисляет остаток от деления?",
options: ["ДЕЛ", "ЧАСТНОЕ", "КВАДРАТ", "ОСТАТ"],
answer: "ОСТАТ",
},
{
question: "Как отобразить скрытые строки?",
options: ["Данные → Сортировка", "Формат → Условное форматирование", "Правый клик → Показать строки", "Вид → Панели"],
answer: "Правый клик → Показать строки",
},
{
question: "Как быстро выделить всю таблицу?",
options: ["Shift + End", "Ctrl + A", "Ctrl + End", "Ctrl + Home"],
answer: "Ctrl + A",
},
{
question: "Какая функция округляет число вниз?",
options: ["ОКРУГЛ", "ОКРУГЛВВЕРХ", "ЦЕЛОЕ", "ОКРУГЛВНИЗ"],
answer: "ОКРУГЛВНИЗ",
},
{
question: "Как объединить данные из разных листов?",
options: ["QUERY", "ВПР", "IMPORTRANGE", "СУММЕСЛИ"],
answer: "IMPORTRANGE",
},
{
question: "Как выделить несколько несмежных ячеек?",
options: ["Shift + стрелки", "Alt + Enter", "Удерживая Ctrl и кликая", "Ctrl + Shift + Tab"],
answer: "Удерживая Ctrl и кликая",
},
{
question: "Какая функция возвращает день месяца?",
options: ["МЕСЯЦ", "ГОД", "ДЕНЬ", "ДАТА"],
answer: "ДЕНЬ",
},
{
question: "Как вставить комментарий в ячейку?",
options: ["Формат → Подпись", "Данные → Примечание", "Файл → Комментарий", "Вставка → Примечание"], 
answer: "Вставка → Примечание",
},
{
question: "Как отобразить формулы в таблице? (Google Sheets)",
options: ["Ctrl + Shift + F", "Alt + =", "Ctrl + `", "Ctrl + /"],
answer: "Ctrl + `",
},
{
question: "Какая функция возвращает длину текста?",
options: ["ПРАВО", "ДЛСТР", "ЛЕВСИМВ", "СЧЁТЗ"],
answer: "ДЛСТР",
},
{
question: "Как автоматически подогнать ширину столбца?",
options: ["Shift + Alt", "Двойной клик по границе заголовка", "Формат → Сжать", "Вид → Настройки"],
answer: "Двойной клик по границе заголовка",
},
{
question: "Как быстро отменить действие?",
options: ["Ctrl + X", "Ctrl + Y", "Ctrl + Q", "Ctrl + Z"],
answer: "Ctrl + Z",
},
{
question: "Какая функция возвращает порядковый номер дня недели?",
options: ["ДАТА", "ДЕНЬНЕД", "ДЕНЬ", "МЕСЯЦ"],
answer: "ДЕНЬНЕД",
},
{
question: "Как вставить только значения без формул?",
options: ["Ctrl + V", "Ctrl + Shift + C", "Правый клик → Вставить значения", "Вставка → Таблица"],
answer: "Правый клик → Вставить значения",
},
{
question: "Какое сочетание открывает окно 'Найти'?",
options: ["Ctrl + H", "Ctrl + Q", "Alt + F", "Ctrl + F"],
answer: "Ctrl + F",
},
{
question: "Какая функция возвращает абсолютное значение числа?",
options: ["МАКС", "ABS", "КОРЕНЬ", "ОКРУГЛ"],
answer: "ABS",
},
{
question: "Как сделать текст жирным?",
options: ["Ctrl + I", "Ctrl + B", "Ctrl + Shift + B", "Alt + B"],
answer: "Ctrl + B",
},
{
question: "Какая функция объединяет массивы данных?",
options: ["IMPORTRANGE", "ARRAYFORMULA", "JOIN", "TEXTJOIN"],
answer: "ARRAYFORMULA",
},
{
question: "Как закрепить первый столбец?",
options: ["Файл → Настройки", "Данные → Сортировка", "Вид → Закрепить → 1 столбец", "Вставка → Таблица"],
answer: "Вид → Закрепить → 1 столбец",
},
{
question: "Как выделить всё содержимое листа?",
options: ["Ctrl + A", "Shift + Ctrl + Home", "Alt + A", "Ctrl + L"],
answer: "Ctrl + A",
},
{
question: "Какой формат сохраняет только текстовые данные?",
options: [".csv", ".xls", ".txt", ".pdf"],
answer: ".txt",
},
{
question: "Как быстро вставить сегодняшнюю дату в Excel?",
options: ["Ctrl + D", "Ctrl + Alt + T", "Ctrl + ;", "Alt + Shift + D"],
answer: "Ctrl + ;",
},
{
question: "Какая функция возвращает номер столбца?",
options: ["СТРОКА", "ИНДЕКС", "ДЛСТР", "СТОЛБЕЦ"],
answer: "СТОЛБЕЦ",
},
{
question: "Как быстро повторить последнее действие? (Google Sheets)",
options: ["Ctrl + Y", "Ctrl + Z", "Ctrl + Shift + R", "Ctrl + Q"],
answer: "Ctrl + Y",
},
{
question: "Какая функция преобразует текст в нижний регистр?",
options: ["ПРОПИСН", "СТРОЧН", "ТЕКСТ", "ЛЕВСИМВ"],
answer: "СТРОЧН",
},
{
question: "Как очистить содержимое ячейки?",
options: ["Ctrl + X", "Ctrl + Shift + D", "Delete", "Alt + Backspace"],
answer: "Delete",
},
{
question: "Какая функция округляет число до целого?",
options: ["ОКРУГЛ", "ОКРУГЛВНИЗ", "ОКРУГЛВВЕРХ", "ЦЕЛОЕ"],
answer: "ЦЕЛОЕ",
},
{
question: "Какой тип диаграммы отображает доли от целого?",
options: ["Круговая", "Столбчатая", "Линейная", "Точечная"],
answer: "Круговая",
},
{
question: "Какая функция возвращает минимальное значение?",
options: ["МАКС", "МИН", "СРЗНАЧ", "СУММ"],
answer: "МИН",
},
{
question: "Как вставить формулу в несколько ячеек сразу? (Excel)",
options: ["Ctrl + C", "Ctrl + V", "Выделить диапазон, ввести формулу и нажать Ctrl + Enter", "Alt + Enter"],
answer: "Выделить диапазон, ввести формулу и нажать Ctrl + Enter",
},
{
question: "Какая функция округляет число вверх?",
options: ["ОКРУГЛ", "ЦЕЛОЕ", "ОКРУГЛВНИЗ", "ОКРУГЛВВЕРХ"],
answer: "ОКРУГЛВВЕРХ",
},
{
question: "Как переместить лист в другую книгу?",
options: ["Правый клик → Переместить или скопировать", "Ctrl + X", "Файл → Сохранить как", "Данные → Импорт"],
answer: "Правый клик → Переместить или скопировать",
},
{
question: "Как сделать текст курсивным?",
options: ["Ctrl + B", "Ctrl + I", "Ctrl + K", "Alt + I"], 
answer: "Ctrl + I",
},
{
question: "Какая функция возвращает случайное число от 0 до 1?",
options: ["СЛУЧМЕЖДУ", "СЛЧИС", "МАКС", "МИН"],
answer: "СЛЧИС",
},
{
question: "Какой формат лучше для импорта данных?",
options: [".pdf", ".docx", ".csv", ".xlsm"],
answer: ".csv",
},
{
question: "Какой инструмент группирует строки по критериям?",
options: ["Сортировка", "Фильтр", "ВПР", "Группировка"],
answer: "Группировка",
},
{
question: "Какая функция возвращает текст из правой части строки?",
options: ["ПРАВСИМВ", "ЛЕВСИМВ", "ДЛСТР", "СЦЕПИТЬ"],
answer: "ПРАВСИМВ",
},
{
question: "Как быстро переместиться в конец таблицы?",
options: ["Ctrl + Home", "Ctrl + End", "Ctrl + Down", "Alt + Q"],
answer: "Ctrl + End",
},
{
question: "Какая функция вычисляет среднее значение с условиями?",
options: ["СЧЁТ", "МАКС", "СРЗНАЧЕСЛИ", "МИН"],
answer: "СРЗНАЧЕСЛИ",
},
{
question: "Как закрепить заголовки и столбцы одновременно?",
options: ["Формат → Зафиксировать", "Файл → Настройки", "Данные → Сортировка", "Вид → Закрепить области"],
answer: "Вид → Закрепить области",
},
{
question: "Какой инструмент позволяет записывать макросы?",
options: ["Вид → Макросы → Запись макроса", "Вставка → Таблица", "Формат → Настройки", "Данные → Импорт"],
answer: "Вид → Макросы → Запись макроса",
},
{
question: "Какая функция возвращает текст из левой части строки?",
options: ["ПРАВО", "ЛЕВСИМВ", "ДЛСТР", "СЦЕПИТЬ"],
answer: "ЛЕВСИМВ",
},
{
question: "Как быстро удалить столбец?",
options: ["Выделить столбец → Ctrl → - ", "Ctrl + X", "Файл → Очистить", "Alt + Backspace"],
answer: "Выделить столбец → Ctrl → - ",
},
{
question: "Какая функция возвращает текущий год?",
options: ["ГОД(СЕГОДНЯ())", "МЕСЯЦ", "ДАТА", "ДЕНЬ"],
answer: "ГОД(СЕГОДНЯ())",
},
{
question: "Какой тип диаграммы лучше для анализа тренда?",
options: ["Круговая", "Линейная", "Столбчатая", "Гистограмма"],
answer: "Линейная",
},
{
question: "Как посчитать количество символов в ячейке?",
options: ["ПРАВО", "ЛЕВСИМВ", "ДЛСТР", "СЧЁТ"],
answer: "ДЛСТР",
},
{
question: "Какой инструмент применяют для сводных диаграмм?",
options: ["Данные → Сортировка", "Формат → Диаграмма", "Файл → Настройки", "Сводная таблица"],
answer: "Сводная таблица",
},
{
question: "Как быстро переместить ячейку на другую строку?",
options: ["Вырезать и вставить", "Ctrl + D", "Ctrl + C", "Alt + Q"],
answer: "Вырезать и вставить",
},
{
question: "Как сделать границы вокруг ячейки?",
options: ["Данные → Сортировка", "Файл → Настройки", "Формат → Границы", "Вставка → Таблица"],
answer: "Формат → Границы",
},
{
question: "Какая функция округляет число до ближайшего целого?",
options: ["ЦЕЛОЕ", "ОКРУГЛВВЕРХ", "ОКРУГЛ", "ОКРУГЛВНИЗ"],
answer: "ОКРУГЛ",
},
{
question: "Как удалить все фильтры?",
options: ["Ctrl + Q", "Файл → Очистить", "Данные → Очистить фильтры", "Вид → Настройки"],
answer: "Данные → Очистить фильтры",
}    
];

export default questions;
